/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Current account state for meter appointment
 */
export type MeterAppointmentState =
  (typeof MeterAppointmentState)[keyof typeof MeterAppointmentState]

export const MeterAppointmentState = {
  traditionalSmartEligible: "traditionalSmartEligible",
  appointmentBooked: "appointmentBooked",
  other: "other",
} as const
